import {
  UpdateUserPreferencesDto,
  UserPreferencesResponse,
} from '../core/preferences';
import { HttpClient } from './http';

export interface PreferencesService {
  getPreferences: () => Promise<UserPreferencesResponse>;
  updatePreferences: (dto: UpdateUserPreferencesDto) => Promise<void>;
}

export function createPreferencesService(
  httpClient: HttpClient,
  baseUrl: string,
): PreferencesService {
  return {
    getPreferences: () => {
      return httpClient<UserPreferencesResponse>(
        `${baseUrl}/preferences`,
        'get',
      );
    },

    updatePreferences: (dto: UpdateUserPreferencesDto) => {
      return httpClient<void>(`${baseUrl}/preferences`, 'patch', { body: dto });
    },
  };
}
